/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * Represents a general screen.
 */

export default class Screen extends Component {

    /**
     * Properties.
     */

    static propTypes = {
        context:                    PropTypes.object.isRequired,
        onLoading:                  PropTypes.func.isRequired,
        onSetActionbarTitle:        PropTypes.func.isRequired,
        onSetActionbarRightIcon:    PropTypes.func
    }
}



// WEBPACK FOOTER //
// ./src/components/Screens/Screen.js